
























import Vue from 'vue'
import { FETCH_NOTE_ATTACHMENT_BY_ID } from '@/store/action-types'

interface ComponentData {
  imageNumber: number | undefined
  image: string | undefined
}

export default Vue.extend({
  name: 'ImageGalleryDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    imageList: Array as () => Array<string>,
    imageIdList: Array as () => Array<number>,
    isCreate: Boolean
  },

  data (): ComponentData {
    return {
      imageNumber: undefined,
      image: undefined
    }
  },

  methods: {

    async getImageUrl (item: number): Promise<void> {
      try {
        let response: any = await this.$store.dispatch(FETCH_NOTE_ATTACHMENT_BY_ID, item)
        this.image = URL.createObjectURL(response)
      } catch {
      }
    },

    onChangeImageNumber(item: number): void {
      this.imageNumber = item
      if(!this.isCreate) {
        this.getImageUrl(this.imageIdList[item])
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onDeleteButtonClick (): void {
      if(this.isCreate) {
        this.$emit('deleteFromImageList', this.imageNumber)
      } else {
        this.$emit('deleteFromImageIdList', this.imageNumber)
      }
    }
  }
})
